// The field in yards (K.POS): origin at the middle of the pitch, x toward the leg side of a right-hander, y toward the bowler.
import type { Position, Zone } from './types';

export type XY = [number, number];

export const POSITIONS: Record<Position, XY> = {
  Slip1: [-8, -24.6], Slip2: [-15.8, -23.2], Slip3: [-22.8, -20], Gully: [-27.5, -12.5],
  ThirdMan: [-24, -56], Point: [-28, -3.5], DeepPoint: [-61, -8], Cover: [-24, 5], ExtraCover: [-19, 15], DeepCover: [-56, 23],
  MidOff: [-11, 27], LongOff: [-19, 57], MidOn: [11, 27], LongOn: [19, 57], Midwicket: [24, 7], DeepMidwicket: [54, 29],
  SquareLeg: [25, -6], DeepSquareLeg: [61, -8], ShortFineLeg: [11, -21], FineLeg: [22, -56],
};
export const KEEPER: XY = [0, -25];
export const KEEPER_UP: XY = [0, -17.5];
export const BOWLER: XY = [2.5, 15.5];
export const STRIKER: XY = [0, -9.4];
export const NON_STRIKER: XY = [-4, 10];

/** Library.Positions depth. The engine's Slip depth stands inside the circle, so it reads Inner here. */
export const DEPTH: Record<Position, 'Inner' | 'Deep'> = {
  Slip1: 'Inner', Slip2: 'Inner', Slip3: 'Inner', Gully: 'Inner', ThirdMan: 'Deep', Point: 'Inner', DeepPoint: 'Deep',
  Cover: 'Inner', ExtraCover: 'Inner', DeepCover: 'Deep', MidOff: 'Inner', LongOff: 'Deep', MidOn: 'Inner', LongOn: 'Deep',
  Midwicket: 'Inner', DeepMidwicket: 'Deep', SquareLeg: 'Inner', DeepSquareLeg: 'Deep', ShortFineLeg: 'Inner', FineLeg: 'Deep',
};

/** K.NAMES: the words under a token when names are on. */
export const NAMES: Record<Position | 'keeper' | 'keeperUp' | 'bowler', string> = {
  Slip1: '1st slip', Slip2: '2nd slip', Slip3: '3rd slip', Gully: 'gully', ThirdMan: 'third man', Point: 'point', DeepPoint: 'deep point',
  Cover: 'cover', ExtraCover: 'extra cover', DeepCover: 'deep cover', MidOff: 'mid-off', LongOff: 'long-off', MidOn: 'mid-on',
  LongOn: 'long-on', Midwicket: 'midwicket', DeepMidwicket: 'deep midwicket', SquareLeg: 'square leg', DeepSquareLeg: 'deep square leg',
  ShortFineLeg: 'short fine leg', FineLeg: 'fine leg', keeper: 'keeper', keeperUp: 'keeper, up', bowler: 'bowler',
};

/** K.ZONES: each zone's wedge in degrees from the striker, 0 toward the bowler, positive toward leg. Cordon points at the slips. */
export const ZONE_ANGLES: Record<Zone, [number, number]> = {
  ThirdMan: [-180, -135], Point: [-135, -90], Cover: [-90, -45], MidOff: [-45, 0],
  MidOn: [0, 45], Midwicket: [45, 90], SquareLeg: [90, 135], FineLeg: [135, 180], Cordon: [-160, -120],
};
